import React from 'react';
import { Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import logo from 'images/panel/Factuxin.svg';

const useStyles = createUseStyles((theme) => ({
    title: {
        ...theme.typography.cardTitle,
        color: theme.color.grayishBlue,
        opacity: 0.7,
        marginLeft: 12
    }
}));

function LogoComponent() {
    const theme = useTheme();
    const classes = useStyles({ theme });
    return (
        <Row> 
            {/*<span className={classes.title}>eMonedero</span>*/}
            <img  src={logo} className="sidebar-logo"/>
        </Row>
    );
}

export default LogoComponent;
